import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithFilemaker_1 from '../../../../../libraries/Images/createAConnectionWithFilemaker_1.png';
import createAConnectionWithFilemaker_2 from '../../../../../libraries/Images/createAConnectionWithFilemaker_2.png';
import createAConnectionWithFilemaker_3 from '../../../../../libraries/Images/createAConnectionWithFilemaker_3.png';
import createAConnectionWithFilemaker_4 from '../../../../../libraries/Images/createAConnectionWithFilemaker_4.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithfilemaker">
                1.&nbsp;{translate('createaconnectionwithfilemaker')}
            </Typography>
            <p>接続を作成するように"新規追加"ボタンをクリック</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_1} width="75%" />
            </Zoom>
            <p>連携できるアプリの一覧が表示されるので、その中から「File Maker」を選択します。</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_2} width="75%" />
            </Zoom>
            <p>「File Maker」をクリックした後、必要な値を入力し、「OK」ボタンをクリックして完了します。</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>接続が正常に作成されると、「File Maker」 カードが表示されます。</p>
            <Zoom>
                <img src={createAConnectionWithFilemaker_4} width="50%"/>
            </Zoom>
            <p>このタグに含まれる<strong>プロバイダ ID</strong> を使用して、File Makerに関する機能を実行します。</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);